import React from "react";
import { UserIcon } from "./user-icon";
import { awaitHelper } from "../../../utils";
import get from "lodash/get";
import PropTypes from "prop-types";

import "./user-profile.m.css";
import { Link } from "@quintype/components";

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserData: false,
      showForm: false
    };
    this.toggleUserData = this.toggleUserData.bind(this);
  }

  toggleUserData() {
    this.setState({ showUserData: !this.state.showUserData });
  }

  toggleForm = event => {
    event.stopPropagation();
    event.preventDefault();
    /* this.setState({ showForm: !this.state.showForm }); */
    this.props.openLoginTemplate();
  };

  async logoutHandler(event, logout) {
    event.persist();
    event.preventDefault();
    event.stopPropagation();
    const { error, data } = await awaitHelper(logout());
    if (error) {
      console.warn(`Logout failed`);
    }
    return data;
  }

  fallbackImage() {
    const image = get(this.props, ["member", "avatar-url"]);
    if (image) {
      return <img styleName="avatar" src={image} />;
    }
    return (
      <span styleName="white">
        <UserIcon width="16px" height="18px" />
      </span>
    );
  }

  render() {
    return (
      <div>
        {!this.props.member ? (
          <div>
            <div onClick={event => this.toggleForm(event)} styleName="sign-btn">
              <span className="white-space" data-test-id="user-profile">
                <UserIcon width="16px" height="18px" />
              </span>
            </div>
          </div>
        ) : (
          <div onClick={this.toggleUserData} styleName="user-details">
            {this.fallbackImage()}
            {this.state.showUserData && (
              <div styleName="overlay">
                <div styleName="user-data">
                  <ul>
                    <li>
                      <Link href={`/user-details`}>My profile</Link>
                    </li>
                    <li>
                      <div>
                        <a href={"#"} onClick={event => this.logoutHandler(event, this.props.logout)}>
                          Logout
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

UserProfile.propTypes = {
  member: PropTypes.object,
  logout: PropTypes.func,
  openLoginTemplate: PropTypes.func
};

export { UserProfile };
